import React from 'react';
import { List } from 'antd';
import { LazyDocument } from 'components/Molecules/Upload/components/LazyDocument/index';

export const ReferenceFile = (props) => {
  const { value = [] } = props;

  return (
    <List
      dataSource={value}
      renderItem={(documentId) => {
        return (
          <LazyDocument
            width={60}
            height={60}
            resource="document-list"
            documentId={documentId}
            type="card"
          />
        );
      }}
    />
  );
};
